export function findCommonPrefix(strings: string[]): string {
  // No common prefix, as there's not enough strings to compare
  if (strings.length === 0) return '';
  if (strings.length === 1) return '';

  const sortedStrings = strings.toSorted();
  const first = sortedStrings.at(0)!;
  const last = sortedStrings.at(-1)!;

  let i = 0;
  while (i < first.length && i < last.length && first[i] === last[i]) {
    i++;
  }

  return first.substring(0, i);
}
